import moment from 'moment'
import {
    SET_CONFIG_ANALYZER_MEASUREMENT,
    SET_CONFIG_UPDATE_ANALYZER_MEASUREMENT,
    SET_END_DATE_ANALYZER_DATE_TIME,
    SET_LIMIT_ANALYZER_MEASUREMENT,
    SET_ORDER_ANALYZER_MEASUREMENT,
    SET_PAGE_ANALYZER_MEASUREMENT,
    SET_SEARCH_ANALYZER_MEASUREMENT,
    SET_START_DATE_ANALYZER_DATE_TIME,
} from '../actions/AnalyzerDateTimeAction'

const initialState = {
    update: null,
    config: null,
    start_date: moment().subtract(6, 'month').toDate(),
    end_date: moment().toDate(),
    page: 1,
    limit: 10,
    search: null,
    order: true,
}

const AnalyzerDateTimeReducer = function (state = initialState, action) {
    switch (action.type) {
        case SET_START_DATE_ANALYZER_DATE_TIME: {
            return {
                ...state,
                start_date: moment(action.payload).toDate(),
            }
        }
        case SET_END_DATE_ANALYZER_DATE_TIME: {
            return {
                ...state,
                end_date: moment(action.payload).toDate(),
            }
        }
        case SET_PAGE_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                page: Number(action.payload) || 1,
            }
        }
        case SET_LIMIT_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                limit: Number(action.payload) || 1,
            }
        }
        case SET_SEARCH_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                search: action.payload || null,
            }
        }
        case SET_ORDER_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                order: Boolean(action.payload),
            }
        }
        case SET_CONFIG_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                config: action.payload,
            }
        }
        case SET_CONFIG_UPDATE_ANALYZER_MEASUREMENT: {
            return {
                ...state,
                update: action.payload,
            }
        }
        default: {
            return state
        }
    }
}

export default AnalyzerDateTimeReducer
